// @ts-nocheck
import React, { useEffect } from "react";
import { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { PostApi } from "../../../../../ApiClient/PostApi";
import { Loader2 } from "../../../../loader/Loader";
import { error_toaster, success_toaster } from "../../../../toaster/Toaster";
// import '../sections/style.css'
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import useFetch from "../../../../../ApiClient/GetApi";

export default function ConsigneeBar() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    contactName: "",
    companyName: "",
    email: "",
    phone: "",
    postal: "",
    country: "",
    city: "",
    province: "",
    address: "",
  });
  const [loading, SetLoading] = useState(false);
  const [phone, setPhone] = useState("");

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const setCountryCode = (phone) => {
    setPhone(phone);
    localStorage.setItem("countryCode", phone);
    setphoneError(false);
  };
  useEffect(() => {
    setData({
      contactName:
        localStorage.getItem("consigneecontactName") !== null
          ? localStorage.getItem("consigneecontactName")
          : "",
      companyName:
        localStorage.getItem("consigneecompanyName") !== null
          ? localStorage.getItem("consigneecompanyName")
          : "",
      email:
        localStorage.getItem("consigneeemail") !== null
          ? localStorage.getItem("consigneeemail")
          : "",
      phone:
        localStorage.getItem("consigneephone") !== null
          ? localStorage.getItem("consigneephone")
          : "",
      postal:
        localStorage.getItem("consigneepostal") !== null
          ? localStorage.getItem("consigneepostal")
          : "",
      country:
        localStorage.getItem("consigneecountry") !== null
          ? localStorage.getItem("consigneecountry")
          : "",
      city:
        localStorage.getItem("consigneecity") !== null
          ? localStorage.getItem("consigneecity")
          : "",
      province:
        localStorage.getItem("consigneeprovince") !== null
          ? localStorage.getItem("consigneeprovince")
          : "",
      address:
        localStorage.getItem("consigneeaddress") !== null
          ? localStorage.getItem("consigneeaddress")
          : "",
    });
    setPhone(
      localStorage.getItem("countryCode") !== null
        ? localStorage.getItem("countryCode")
        : ""
    );
  }, []);

  const [contactNameError, setContactNameError] = useState(false);
  const [companyNameError, setcompanyNameError] = useState(false);
  const [emailError, setemailError] = useState(false);
  const [phoneError, setphoneError] = useState(false);
  const [postalError, setpostalError] = useState(false);
  const [countryError, setcountryError] = useState(false);
  const [cityError, setcityError] = useState(false);
  const [addressError, setaddressError] = useState(false);
  const [provinceError, setprovinceError] = useState(false);

  const onChange = (e) => {
    if (e.target.name === "companyName") {
      setcompanyNameError(false);
      localStorage.setItem("consigneecompanyName", e.target.value);
    }
    if (e.target.name === "contactName") {
      setContactNameError(false);
      localStorage.setItem("consigneecontactName", e.target.value);
    }
    if (e.target.name === "email") {
      setemailError(false);
      localStorage.setItem("consigneeemail", e.target.value);
    }
    if (e.target.name === "phone") {
      setphoneError(false);
      localStorage.setItem("consigneephone", e.target.value);
    }
    if (e.target.name === "postal") {
      setpostalError(false);
      localStorage.setItem("consigneepostal", e.target.value);
    }
    if (e.target.name === "country") {
      setcountryError(false);
      localStorage.setItem("consigneecountry", e.target.value);
    }
    if (e.target.name === "city") {
      setcityError(false);
      localStorage.setItem("consigneecity", e.target.value);
    }
    if (e.target.name === "province") {
      setprovinceError(false);
      localStorage.setItem("consigneeprovince", e.target.value);
    }
    if (e.target.name === "address") {
      setaddressError(false);
      localStorage.setItem("consigneeaddress", e.target.value);
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const add_consignee_detail = async () => {
    if (data.companyName === "") {
      setcompanyNameError(true);
      return false;
    }
    if (data.contactName === "") {
      setContactNameError(true);
      return false;
    }
    if (data.email === "") {
      setemailError(true);
      return false;
    }
    const check = validateEmail(data.email);
    if (check === null) {
      error_toaster("Email is not valid!");
      return false;
    }
    if (phone === "") {
      setphoneError(true);
      return false;
    }
    if (data.postal === "") {
      setpostalError(true);
      return false;
    }
    if (data.country === "") {
      setcountryError(true);
      return false;
    }
    if (data.city === "") {
      setcityError(true);
      return false;
    }
    if (data.province === "") {
      setprovinceError(true);
      return false;
    }
    if (data.address === "") {
      setaddressError(true);
      return false;
    }
    SetLoading(true);
    const res = await PostApi("booking/add_consignee_detail", {
      contactName: data.contactName,
      companyName: data.companyName,
      email: data.email,
      phone: phone,
      postalCode: data.postal,
      country: data.country,
      city: data.city,
      province: data.province,
      address: data.address,
      location: "/destination_details",
      booking_id: localStorage.getItem("orderId"),
    });

    if (res.data.status === "1") {
      success_toaster(res.data.message);
      SetLoading(false);
      // setData({ contactName: "", companyName: "", email: "", phone: "", postal: "", country: "", city: "", province: "", address: "" });
      navigate("/destination_details");
    } else {
      error_toaster(res.data.message);
      SetLoading(false);
    }
  };

  const inputStyle =
    "border-none bg-white rounded p-3 placeholder:text-black placeholder:text-opacity-40 font-normal text-base focus:ring-0 w-full";
  const labelStyle = "font-normal text-black";
  const inputNumber =
    "input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {-webkit-appearance: none;margin: 0;}input[type=number] {-moz-appearance: textfield;}";
  return (
    <>
      <style>{inputNumber}</style>
      {loading ? (
        <div className="absolute left-[60%] top-[40%]">
          <Loader2 />
        </div>
      ) : (
        <div
          className="xl:col-span-9 lg:col-span-8 bg-themeSecondary py-6 sm:px-8 px-4 flex 
        flex-col justify-between gap-y-8"
        >
          <div className="space-y-8">
            <h1 className="col-span-2 font-medium text-2xl text-themeRed">
              Consignee Details
            </h1>

            <div className="grid md:grid-cols-2 xl:gap-x-16 md:gap-x-8 gap-y-8">
              <div className="sm:space-y-8 space-y-4">
                <div className="space-y-2">
                  <label htmlFor="companyName" className={labelStyle}>
                    Company name
                  </label>
                  <input
                    onChange={onChange}
                    value={data.companyName}
                    type="text"
                    placeholder="Enter your company name"
                    name="companyName"
                    id="companyName"
                    className={inputStyle}
                  />
                  {companyNameError ? (
                    <span className="text-themeRed text-xs">
                      Company Name is required!
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="space-y-2">
                  <label htmlFor="contactName" className={labelStyle}>
                    Contact name
                  </label>
                  <input
                    onChange={onChange}
                    value={data.contactName}
                    type="text"
                    placeholder="Enter name"
                    name="contactName"
                    id="contactName"
                    className={inputStyle}
                  />
                  {contactNameError ? (
                    <span className="text-themeRed text-xs">
                      Contact Name is required!
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="space-y-2">
                  <label htmlFor="email" className={labelStyle}>
                    Email
                  </label>
                  <input
                    onChange={onChange}
                    value={data.email}
                    type="email"
                    placeholder="georgia.young@example.com"
                    name="email"
                    id="email"
                    className={inputStyle}
                  />
                  {emailError ? (
                    <span className="text-themeRed text-xs">
                      Email is required!
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="grid sm:grid-cols-1 gap-x-3 gap-y-4">
                  <div className="space-y-2">
                    <label htmlFor="phone" className={labelStyle}>
                      Phone no
                    </label>
                    <div>
                      <PhoneInput
                        inputProps={{ name: "phone", id: "phone" }}
                        inputStyle={{
                          paddingLeft: "44px",
                          paddingTop: "20px",
                          paddingBottom: "20px",
                          paddingRight: "12px",
                          background: "white",
                          border: "none",
                          width: "100%",
                        }}
                        country={"za"}
                        enableSearch={true}
                        value={phone}
                        onChange={(phone) => setCountryCode(phone)}
                      />
                    </div>
                    {/* <input
                      onChange={onChange}
                      value={data.phone}
                      type="number"
                      maxLength={15}
                      minLength={11}
                      placeholder="+1 123 4567890"
                      name="phone"
                      id="phone"
                      className={inputStyle}
                    /> */}
                    {phoneError ? (
                      <span className="text-themeRed text-xs">
                        Phone Num is required!
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="sm:space-y-8 space-y-4">
                <div className="space-y-2">
                  <label htmlFor="country" className={labelStyle}>
                    Country
                  </label>
                  <input
                    onChange={onChange}
                    value={data.country}
                    type="text"
                    placeholder="Enter your country"
                    name="country"
                    id="country"
                    className={inputStyle}
                  />
                  {countryError ? (
                    <span className="text-themeRed text-xs">
                      Country is required!
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="grid sm:grid-cols-2 gap-x-3 gap-y-4">
                  <div className="space-y-2">
                    <label htmlFor="city" className={labelStyle}>
                      City
                    </label>
                    <input
                      onChange={onChange}
                      value={data.city}
                      type="text"
                      placeholder="City name"
                      name="city"
                      id="city"
                      className={inputStyle}
                    />
                    {cityError ? (
                      <span className="text-themeRed text-xs">
                        City is required!
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="province" className={labelStyle}>
                      Province
                    </label>
                    <input
                      onChange={onChange}
                      value={data.province}
                      type="text"
                      placeholder="Province"
                      name="province"
                      id="province"
                      className={inputStyle}
                    />
                    {provinceError ? (
                      <span className="text-themeRed text-xs">
                        Province is required!
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="space-y-2">
                  <label htmlFor="address" className={labelStyle}>
                    Address
                  </label>
                  <input
                    onChange={onChange}
                    value={data.address}
                    type="text"
                    placeholder="Enter your address"
                    name="address"
                    id="address"
                    className={inputStyle}
                  />
                  {addressError ? (
                    <span className="text-themeRed text-xs">
                      Address is required!
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="space-y-2">
                  <label htmlFor="postal" className={labelStyle}>
                    Postal code
                  </label>
                  <input
                    onChange={onChange}
                    value={data.postal}
                    type="number"
                    placeholder="54200"
                    name="postal"
                    id="postal"
                    className={inputStyle}
                  />
                  {postalError ? (
                    <span className="text-themeRed text-xs">
                      Postal Code is required!
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex sm:flex-row flex-col sm:justify-end sm:items-center gap-x-4 gap-y-3">
            <div>
              <Link
                className="bg-transparent text-themeBlue font-medium xl:text-xl lg:text-lg py-3 px-12 rounded-lg 
                    border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-themeBlue 
                    hover:text-white sm:w-auto w-full"
                to="/supplier_details"
              >
                <FaArrowLeft />
                <span>Back</span>
              </Link>
            </div>
            <div>
              <Link
                className="bg-themeBlue text-white font-medium xl:text-xl lg:text-lg py-3 px-12 rounded-lg 
                    border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-transparent hover:text-themeBlue 
                    sm:w-auto w-full"
                onClick={add_consignee_detail}
              >
                <span>Next</span>
                <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
